document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-variant-select]").forEach((select) => {
    const form = select.closest("form");
    const info = form?.closest(".product-info");
    const price = info?.querySelector("[data-variant-price]");
    const compare = info?.querySelector("[data-variant-compare]");
    const status = info?.querySelector("[data-variant-status]");
    const submit = form?.querySelector("[data-add-to-cart]");
    const optionPicker = form?.querySelector("[data-product-options]");
    const fallbackPicker = form?.querySelector("[data-variant-fallback]");
    const variantData = form?.querySelector("[data-variant-data]");
    const gallery = form?.closest(".product-layout")?.querySelector("[data-product-gallery]");
    const optionGroups = optionPicker
      ? Array.from(optionPicker.querySelectorAll("[data-option-group]"))
      : [];
    let variants = [];

    try {
      variants = JSON.parse(variantData?.textContent || "[]");
    } catch (error) {
      console.error("Unable to read Shopify variant data.", error);
    }

    if (!variants.length || !optionGroups.length) {
      const updateFallbackVariant = () => {
        const option = select.options[select.selectedIndex];
        if (!option) return;
        if (price) price.textContent = option.dataset.price || "";
        if (compare) {
          compare.textContent = option.dataset.comparePrice || "";
          compare.hidden = !option.dataset.comparePrice;
        }
        const available = option.dataset.available === "true";
        if (status) {
          status.textContent = available ? "Available" : "Out of stock";
          status.dataset.available = String(available);
        }
        if (submit) {
          submit.disabled = !available;
          submit.textContent = available ? submit.dataset.addLabel : submit.dataset.soldLabel;
        }
      };
      select.addEventListener("change", updateFallbackVariant);
      updateFallbackVariant();
      return;
    }

    const colorIndex = Number(gallery?.dataset.colorOptionIndex);
    const hasColorOption = Number.isInteger(colorIndex) && colorIndex >= 0;
    let currentVariant = variants.find((variant) => String(variant.id) === select.value) || variants[0];
    if (optionPicker) optionPicker.hidden = false;
    if (fallbackPicker) fallbackPicker.hidden = true;

    const readSelections = () => optionGroups.map((group) => {
      const checked = group.querySelector("[data-product-option-choice]:checked");
      const dropdown = group.querySelector("[data-product-option-select]");
      return checked?.value ?? dropdown?.value ?? "";
    });

    const syncOptionControls = (variant) => {
      optionGroups.forEach((group, index) => {
        const selectedValue = variant.options?.[index] ?? "";
        group.querySelectorAll("[data-product-option-choice]").forEach((input) => {
          input.checked = input.value === selectedValue;
        });
        const dropdown = group.querySelector("[data-product-option-select]");
        if (dropdown) dropdown.value = selectedValue;
        const selectedLabel = group.querySelector("[data-selected-option-value]");
        if (selectedLabel) selectedLabel.textContent = selectedValue;
      });
    };

    const refreshOptionAvailability = (variant) => {
      optionGroups.forEach((group, index) => {
        const selectedValue = variant.options?.[index];
        const updateDisabled = (control) => {
          const hasAvailableVariant = variants.some((candidate) =>
            candidate.available && candidate.options?.[index] === control.value
          );
          control.disabled = !hasAvailableVariant && control.value !== selectedValue;
        };
        group.querySelectorAll("[data-product-option-choice]").forEach(updateDisabled);
        const dropdown = group.querySelector("[data-product-option-select]");
        if (dropdown) Array.from(dropdown.options).forEach(updateDisabled);
      });
    };

    const updateVariantDetails = (variant) => {
      if (price) price.textContent = variant.price || "";
      if (compare) {
        compare.textContent = variant.comparePrice || "";
        compare.hidden = !variant.comparePrice;
      }
      if (status) {
        status.textContent = variant.available ? "Available" : "Out of stock";
        status.dataset.available = String(variant.available);
      }
      if (submit) {
        submit.disabled = !variant.available;
        const label = variant.available ? submit.dataset.addLabel : submit.dataset.soldLabel;
        const textNode = Array.from(submit.childNodes).find((node) => node.nodeType === Node.TEXT_NODE);
        if (textNode) textNode.textContent = `${label} `;
        else submit.textContent = label;
        const arrow = submit.querySelector("[aria-hidden='true']");
        if (arrow) arrow.hidden = !variant.available;
      }
      select.value = String(variant.id);
      currentVariant = variant;
    };

    const filterGallery = (variant) => {
      if (!gallery || !hasColorOption) return;
      const selectedColor = variant.options?.[colorIndex] || "";
      const colorByMediaId = new Map();
      variants.forEach((candidate) => {
        const mediaId = candidate.featuredMediaId;
        const color = candidate.options?.[colorIndex];
        if (!mediaId || !color) return;
        const key = String(mediaId);
        if (colorByMediaId.has(key) && colorByMediaId.get(key) !== color) {
          colorByMediaId.set(key, null);
        } else if (!colorByMediaId.has(key)) {
          colorByMediaId.set(key, color);
        }
      });

      let visibleIndex = 0;
      gallery.querySelectorAll("[data-gallery-item]").forEach((item) => {
        const variantColor = colorByMediaId.get(item.dataset.mediaId);
        const itemColor = item.dataset.galleryColor || variantColor || "";
        if (!item.dataset.galleryColor && variantColor) item.dataset.galleryColor = variantColor;
        const visible = !itemColor || itemColor === selectedColor;
        item.hidden = !visible;
        item.classList.toggle("is-primary", visible && visibleIndex === 0);
        if (visible) {
          visibleIndex += 1;
          const count = item.querySelector("[data-view-count]");
          if (count) count.textContent = `VIEW ${visibleIndex}`;
        }
      });
      const placeholder = gallery.querySelector("[data-gallery-placeholder]");
      if (placeholder) placeholder.hidden = visibleIndex > 0;
      gallery.dataset.selectedColor = selectedColor;
    };

    const setVariant = (variant) => {
      if (!variant) return;
      syncOptionControls(variant);
      refreshOptionAvailability(variant);
      updateVariantDetails(variant);
      filterGallery(variant);
    };

    optionGroups.forEach((group) => {
      group.addEventListener("change", (event) => {
        const control = event.target.closest("[data-product-option-choice], [data-product-option-select]");
        if (!control) return;
        const changedIndex = Number(group.dataset.optionIndex);
        const selectedOptions = readSelections();
        let variant = variants.find((candidate) =>
          candidate.options?.length === selectedOptions.length &&
          candidate.options.every((value, index) => value === selectedOptions[index])
        );

        if (!variant) {
          const changedValue = selectedOptions[changedIndex];
          const candidates = variants
            .filter((candidate) => candidate.available && candidate.options?.[changedIndex] === changedValue)
            .sort((a, b) => {
              const score = (candidate) => candidate.options.reduce(
                (total, value, index) => total + (index !== changedIndex && value === selectedOptions[index] ? 1 : 0),
                0
              );
              return score(b) - score(a);
            });
          variant = candidates[0] || variants.find(
            (candidate) => candidate.options?.[changedIndex] === changedValue
          );
        }

        setVariant(variant || currentVariant);
      });
    });

    setVariant(currentVariant);
  });

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const desktopPointer = window.matchMedia("(min-width: 801px) and (hover: hover) and (pointer: fine)");
  const scene = document.querySelector("[data-scroll-scene]");
  const frame = scene?.querySelector("[data-scroll-frame]");

  if (scene && frame) {
    let scheduled = false;
    const updateScroll = () => {
      scheduled = false;
      if (reducedMotion.matches || !desktopPointer.matches) {
        frame.style.removeProperty("--scroll-shift");
        return;
      }
      const bounds = scene.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, (window.innerHeight - bounds.top) / (window.innerHeight + bounds.height)));
      frame.style.setProperty("--scroll-shift", `${Math.round((progress - 0.5) * 86)}px`);
    };
    const scheduleScroll = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(updateScroll);
    };
    window.addEventListener("scroll", scheduleScroll, { passive: true });
    window.addEventListener("resize", scheduleScroll);
    reducedMotion.addEventListener("change", scheduleScroll);
    desktopPointer.addEventListener("change", scheduleScroll);
    scheduleScroll();
  }

  const revealItems = document.querySelectorAll("[data-reveal]");
  if (revealItems.length && "IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: "0px 0px -32px 0px" });
    revealItems.forEach((item) => observer.observe(item));
    const syncMotion = () => document.body.classList.toggle("motion-ready", !reducedMotion.matches);
    reducedMotion.addEventListener("change", syncMotion);
    syncMotion();
  }
});